import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { TranslationService } from '../../common/services/languages/translation.service';
import { NgRedux } from '@angular-redux/store';
import { AppState } from '../../store/state.model';
import { NgIf } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-user-roles',
    templateUrl: './user-roles.component.html',
    styleUrls: ['./user-roles.component.scss'],
    imports: [NgIf, MatButton, TranslatePipe]
})
export class UserRolesComponent implements OnInit {

  /**
  *@arg fileType will emitt file type flag when respected role is selected
  **/
  @Output() fileType: EventEmitter<string> = new EventEmitter<string>();
  /**
  *@arg userAvailableRoles store the roles of the user
  **/
  public userAvailableRoles: Array<string>;
  /**
  *@arg canSubmit Set the privilege of the user if they can submit
  **/
  public canSubmit: boolean;
  /**
 *@arg canApprove Set the privilege of the user if they can review
 **/
  public canApprove: boolean;

  constructor(
    public translate: TranslationService,
    public router: Router,
    public ngRedux: NgRedux<AppState>) {
    if (!!this.ngRedux.getState().auth) {
      this.userAvailableRoles = this.ngRedux.getState().auth.userAvailableRoles;
    }
    this.changePrivileges();
  }
  /**
   * @function ngOnInit Method to Initializes the component and perform initial operations
   */
  ngOnInit(): void {
  }

  /**
   *@arg changePrivileges will set the privileges for users based on their roles
   **/
  public changePrivileges(): void {
    if (this.userAvailableRoles.indexOf('SUBMITTER') > -1 || this.userAvailableRoles.indexOf('REVIEWER') > -1) {
      this.canSubmit = true;
      this.canApprove = false;
    } else if (this.userAvailableRoles.indexOf('APPROVER') > -1) {
      this.canSubmit = true;
      this.canApprove = true;
    } else {
      this.canSubmit = false;
      this.canApprove = false;
    }
  }
  /**
  *@arg setFileType will emit the setFileType flag
  **/
  public setFileType(value: string): void {
    this.fileType.emit(value);
  }
}
